<template>
  <div class="alls">
    <!-- 头部 -->
    <b-container class=" bv-example-row">
      <b-row>
        <b-col cols="12">
          <div class="title mt-6">
            <div class="title-text">Understand the process</div>
            <div class="title-name">你需要了解的留学流程!</div>
            <div class="title-welcome">
              <span>留学专业服务</span>
              <span>SERVICES</span>
            </div>
          </div>
        </b-col>
      </b-row>
      <!-- 列表 -->
      <b-row align-h="center">
        <b-col class="subject" cols="12" md="5" lg="5" xl="5">
          <img src="https://honeybee-cn.oss-cn-beijing.aliyuncs.com/images/eg1.png" alt="" />
          <img class="cet-logo" src="../../images/cet-logo.png" alt="" />
        </b-col>
        <b-col class="subject" cols="12" md="5" lg="5" xl="5">
          <img src="../../images/cet-bg.png" alt="" />
          <div class="subject-content">
            <div>选校</div>
            <div>一</div>
            <div>超值服务、精准定位、专业分析</div>
            <div class="subject-price">
              <span>
                <span style="font-size: 16px;">¥</span>
                69
              </span>
              <span>原价¥ 199</span>
            </div>
            <div>
              <!-- 	查看详情
							<span class="gt"><img src="../../images/gt.svg" alt="" /></span> -->
            </div>
          </div>
        </b-col>
      </b-row>
      <!-- 列表 -->
      <b-row align-h="center">
        <b-col class="subject" cols="12" md="5" lg="5" xl="5">
          <img src="https://honeybee-cn.oss-cn-beijing.aliyuncs.com/images/eg2.png" alt="" />
          <img class="cet-logo" src="../../images/cet-logo.png" alt="" />
        </b-col>
        <b-col class="subject" cols="12" md="5" lg="5" xl="5">
          <img src="../../images/cet-bg.png" alt="" />
          <div class="subject-content">
            <div>文书、网申和签证服务</div>
            <div>一</div>
            <div>
              深度定制，专业服务
              <img style="width: 1rem!important;margin-left:0.3125rem;" src="../../images/medal.png" alt="" />
            </div>
            <div class="subject-price">
              <span>
                <span style="font-size: 16px;">¥</span>
                5000起
              </span>
              <span>原价¥28888</span>
            </div>
            <div>
              <!-- 		查看详情
							<span class="gt"><img src="../../images/gt.svg" alt="" /></span> -->
            </div>
          </div>
        </b-col>
      </b-row>
      <!-- 咨询 -->
      <b-row>
        <b-col cols="12">
          <div class="title consulting mt-6">
            <div class="title-text">You need to ask us?</div>
            <div class="title-name">你需要问我们什么？</div>
            <div class="title-welcome">
              <span>留学咨询</span>
              <span>CONSULTING</span>
            </div>
          </div>
        </b-col>
      </b-row>
      <b-row align-h="center" class="list">
        <b-col cols="12" md="10" lg="10" xl="10" class="consulting-list">
          <div class="qa">Q/A</div>
          <!-- 咨询列表 -->
          <b-row class="list-content">
            <b-col cols="12" md="5" lg="5" xl="5" class="d1"><img src="https://honeybee-cn.oss-cn-beijing.aliyuncs.com/images/studyabroad-consulting1.jpg" alt="" /></b-col>
            <b-col cols="12" md="5" lg="7" xl="7" class="d2">
              <div class="listcontent-top">
                <div class="listcontent-left">
                  <img src="../../images/true.png" alt="" />
                  <span>为什么要出国留学?</span>
                </div>
                <div class="look-detail">
                  <a href="https://mp.weixin.qq.com/s/oAGUSzI5ZvBuSwb8NKdVbQ" target="_blank">
                    <span>查看详情</span>
                    <img src="../../images/backgt.png" alt="" />
                  </a>
                </div>
              </div>
              <div class="l-detail">
                “为什么选择留学？” 镀金？留在国外？父母命令？亦或者只是想换个地方生活。
                相信大多数留学生在最开始决定出国的时候，都不知道该如何回答这个问题。虽然出国是自己的选择，但关于为什么出国，最开始的回答都是含糊其辞
              </div>
            </b-col>
          </b-row>
          <!-- 咨询列表 -->
          <b-row class="list-content">
            <b-col cols="12" md="5" lg="5" xl="5" class="d1"><img src="https://honeybee-cn.oss-cn-beijing.aliyuncs.com/images/studyabroad-consulting2.jpg" alt="" /></b-col>
            <b-col cols="12" md="5" lg="7" xl="7" class="d2">
              <div class="listcontent-top">
                <div class="listcontent-left">
                  <img src="../../images/true.png" alt="" />
                  <span>【嗡嗡offer墙】17天雅思从5.5提升到6.5的秘密，加拿大名校12.5万元全额奖学金加持！</span>
                </div>
                <div class="look-detail">
                  <a href="https://mp.weixin.qq.com/s/J93Ul65EE4IFR_ly4evD0Q" target="_blank">
                    <span>查看详情</span>
                    <img src="../../images/backgt.png" alt="" />
                  </a>
                </div>
              </div>
              <div class="l-detail">
                日益上涨的留学费用让出国读书变成了越来越花钱的事情，但有的同学却能在未入学时就挣出一笔留学费用，帮家里分担，这都得益于学校为优秀学生准备的“全！额！奖！学！金！”。还是名额有限的那种~
                今年有很多嗡嗡雅思的同学都拿到了让人羡慕不已的各类奖学金，李同学就是其中一位！
              </div>
            </b-col>
          </b-row>
          <!-- 咨询列表 -->
          <b-row class="list-content">
            <b-col cols="12" md="5" lg="5" xl="5" class="d1"><img src="https://honeybee-cn.oss-cn-beijing.aliyuncs.com/images/studyabroad-consulting3.jpg" alt="" /></b-col>
            <b-col cols="12" md="5" lg="7" xl="7" class="d2">
              <div class="listcontent-top">
                <div class="listcontent-left">
                  <img src="../../images/true.png" alt="" />
                  <span>疫情下的留学趋势与选择！</span>
                </div>
                <div class="look-detail">
                  <a href="https://mp.weixin.qq.com/s/M8q-rbltRTIodHkn3AVmdA" target="_blank">
                    <span>查看详情</span>
                    <img src="../../images/backgt.png" alt="" />
                  </a>
                </div>
              </div>
              <div class="l-detail">
                中国教育在线总编辑、教育改革与治理研究专家陈志文受中国儿童少年基金会“护航计划”邀请，就《疫情下的留学趋势与选择》一题展开了一场精彩的线上直播讲座。
                以下分享陈总编辑讲座内容，以飨读者。
                <br />
                陈总编从两个层面分析了疫情对留学带来的影响，即：
                <br />
                宏观上：疫情让原已增长乏力的留学趋势提前进入拐点；
                <br />
                微观上：当前政策对个人申学而言不似想象中那样艰难。
              </div>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  name: 'App',
  created () {},
  methods: {
    back () {
      this.$router.push('/')
    },
    go () {
      this.$router.push('/cet')
    }
  }
}
</script>

<style>
.go-detail,
.look-detail {
  cursor: pointer;
}
.l-detail {
  margin-top: 2.8125rem;
  font-size: 1rem;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
  margin-bottom: 1.25rem;
}
.look-detail span {
  font-size: 0.75rem !important;
  font-weight: 400 !important;
}
.look-detail img {
  width: 0.59375rem !important;
  height: 0.59375rem !important;
  margin-left: 0.3125rem;
}
.listcontent-top {
  display: flex;
  justify-content: space-between;
  margin-top: 1.25rem;
}
.listcontent-top img {
  width: 1.375rem;
  height: 1.125rem;
}
.listcontent-left {
  max-width: 70%;
}
.listcontent-top span {
  font-size: 1.125rem;
  font-weight: bolder;
  color: #000000;
}
.list-content {
  margin-top: 1.875rem;
  padding-bottom: 1.25rem;
}
.d1,
.d2 {
  width: 100%;
}
.d1 img {
  width: 90%;
  max-height: 15rem;
  margin: 0 auto;
}
.qa {
  width: 4.0625rem;
  height: 4.0625rem;
  border-radius: 50%;
  background-color: #28352c;
  font-size: 1.4375rem;
  font-weight: 400;
  color: #eeeeee;
  line-height: 4.0625rem;
  margin: -2rem auto 0 auto;
}
.consulting-list {
  background-color: #eeeeee;
  position: relative;
}
* {
  font-family: 'pictograph';
}
.alls {
  width: 100%;
  overflow: hidden;
}
.mt-6 {
  margin-top: 3rem !important;
}
.mt-8 {
  margin-top: 5rem !important;
}
.mt-10 {
  margin-top: 7rem !important;
}
.title {
  margin: 0 auto 4.3125rem auto;
  text-align: left;
  display: inline-block;
}
.title-text {
  /* 	font-size: 12px;
	transform: scale(0.7);
	margin-left: -23px; */
  font-size: 0.75rem;
  font-family: FZLanTingHei-DB-GBK;
  color: #28352c;
  transform: scale(0.7);
  margin-left: -1.875rem;
}
.title-name {
  font-weight: bold;
  font-size: 1.5rem;
}
.title-welcome {
  margin-top: 0.625rem;
}
.title-welcome span:nth-child(1) {
  background: #28352c;
  box-shadow: 0.1875rem 0.3125rem 0.5625rem 0.0625rem rgba(0, 0, 0, 0.31);
  border-radius: 0.3125rem;
  color: #ffffff;
  padding: 0.3125rem 0.5625rem;
}
.title-welcome span:nth-child(2) {
  color: #000000;
  font-size: 0.75rem;
  font-weight: bold;
  margin-left: 0.5rem;
}
.subject {
  padding: 0 !important;
  position: relative;
  margin-bottom: 3rem;
}
.subject img {
  width: 100%;
}
.cet-logo {
  position: absolute;
  top: 1rem;
  left: 1rem;
  width: 2.225rem !important;
}
.subject-content {
  position: absolute;
  padding-left: 1.75rem;
  bottom: 0;
  width: 100%;
  text-align: left;
}
.subject-content div:nth-child(1) {
  font-size: 1.2375rem;
  font-weight: 400;
  color: #f2c52d;
}
.subject-content div:nth-child(2) {
  font-size: 1.4375rem;
  font-weight: 400;
  color: #f2c52d;
}
.subject-content div:nth-child(3) {
  font-size: 0.8125rem;
  font-weight: 400;
  color: #f2c52d;
  margin-bottom: 0.8125rem;
}

.subject-price span:nth-child(1) {
  font-size: 1.3125rem;
  font-weight: 400;
  color: #f2c52d;
}
.subject-price span:nth-child(2) {
  font-size: 0.625rem;
  font-weight: 500;
  color: #ffffff;
  text-decoration: line-through;
  margin-left: 2.875rem;
}
.subject-content div:nth-child(5) {
  margin-top: 1rem;
  margin-bottom: 1.6875rem;
  font-size: 0.6875rem;
  font-weight: 400;
  color: #ffffff;
  display: flex;
}

.gt {
  width: 1rem;
  height: 1rem;
  margin-left: 0.95rem;
  display: block;
  text-align: center;
  margin-top: -0.15rem;
}
.gt img {
  width: 100%;
  height: 100%;
}

.consulting {
  margin-top: 0 !important;
}

/* 小屏幕（平板，大于等于 768px） */
@media (min-width: @screen-sm-min) {
  .mt-6 {
    margin-top: 3rem !important;
  }
  .mt-8 {
    margin-top: 5rem !important;
  }
  .mt-10 {
    margin-top: 8rem !important;
  }
  .subject-price span:nth-child(1) {
    font-size: 1.3125rem;
  }
  .subject {
    margin-bottom: 5rem;
  }
  .subject-content {
    padding-left: 3.75rem;
  }

  .subject-price {
    margin-bottom: 3.75rem;
  }

  .subject-price span:nth-child(2) {
    margin-left: 2.875rem;
  }
  .subject-content div:nth-child(5) {
    margin-bottom: 2.6875rem;
  }
}

/* 中等屏幕（桌面显示器，大于等于 992px） */
@media (min-width: @screen-md-min) {
  .mt-6 {
    margin-top: 6rem !important;
  }
  .mt-8 {
    margin-top: 8rem !important;
  }
  .mt-10 {
    margin-top: 10rem !important;
  }
  .subject {
    margin-bottom: 5rem;
  }
  .subject-content {
    padding-left: 3.75rem;
  }

  .subject-price {
    margin-bottom: 3.75rem;
  }

  .subject-price span:nth-child(2) {
    margin-left: 2.875rem;
  }
  .subject-content div:nth-child(5) {
    margin-bottom: 2.6875rem;
  }
}

/* 大屏幕（大桌面显示器，大于等于 1200px） */
@media (min-width: @screen-lg-min) {
  .mt-6 {
    margin-top: 6rem !important;
  }
  .mt-8 {
    margin-top: 8rem !important;
  }
  .mt-10 {
    margin-top: 10rem !important;
  }
  .subject {
    margin-bottom: 5rem;
  }
  .subject-content {
    padding-left: 3.75rem;
  }

  .subject-price {
    margin-bottom: 3.75rem;
  }

  .subject-price span:nth-child(2) {
    margin-left: 2.875rem;
  }
  .subject-content div:nth-child(5) {
    margin-bottom: 2.6875rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/studyabroad/studyabroad.vue